import React from 'react';
import { Container, Typography, Grid, Box, useTheme } from '@mui/material';
import SchoolIcon from '@mui/icons-material/School';
import WorkIcon from '@mui/icons-material/Work';
import { EducationCard, Divider, IconWrapper } from '../styles/EducationStyles';
import { useEducation } from '../utils/EducationUtils';

const EducationComp = () => {
  const theme = useTheme();
  const { title, items } = useEducation();

  return (
    <Container maxWidth="lg" sx={{ py: 8 }} id="education">
      <Typography variant="h3" gutterBottom align="center" sx={{ 
        mb: 6, 
        fontWeight: 'bold', 
        background: theme.palette.mode === 'dark'
          ? 'linear-gradient(135deg, #4B0082 0%, #1A2980 50%, #26D0CE 100%)'
          : 'linear-gradient(135deg, #FF6B6B 0%, #6A5ACD 50%, #00CED1 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
      }}>
        {title}
      </Typography>
      <Box sx={{ position: 'relative', mb: 8 }}>
        <Divider />
        <Grid container spacing={6}>
          <Grid item xs={12} md={6}>
            <EducationCard elevation={6} position="top">
              <Box>
                <IconWrapper position="top">
                  <SchoolIcon fontSize="large" />
                </IconWrapper>
                <Typography variant="h5" gutterBottom fontWeight="bold">
                  {items.top.heading}
                </Typography>
                <Typography variant="subtitle1" gutterBottom>
                  {items.top.subheading}
                </Typography>
                {items.top.lines.map((text, idx) => (
                  <Typography key={idx} variant="body2" sx={idx === 0 ? undefined : { mt: 2 }}>
                    {text}
                  </Typography>
                ))}
              </Box>
            </EducationCard>
          </Grid>
          <Grid item xs={12} md={6}>
            <EducationCard elevation={6} position="bottom">
              <Box>
                <IconWrapper position="bottom">
                  <WorkIcon fontSize="large" />
                </IconWrapper>
                <Typography variant="h5" gutterBottom fontWeight="bold">
                   {items.bottom.heading}
                </Typography>
                <Typography variant="subtitle1" gutterBottom>
                  {items.bottom.subheading}
                </Typography>
                {items.bottom.lines.map((text, idx) => (
                  <Typography key={idx} variant="body2" sx={{ mt: 2 }}>
                    {text}
                  </Typography>
                ))}
              </Box>
            </EducationCard>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default EducationComp;
